import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useDeliveryTerms = defineStore('delivery-terms', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.deliveryTerm_List,
    dto: 'DeliveryTermDto',
    create: api.deliveryTerm_Create,
    update: api.deliveryTerm_Update,
    delete: api.deliveryTerm_Delete,
    usage: api.deliveryTerm_GetDeliveryTermUsage,
    signalR: 'DeliveryTermUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
